<template>
    <v-app>
        <v-main>
            <v-container>
                <v-layout justify-center>
                    <v-flex xs12 sm12 md12 lg12 xl6>
                        <v-card-text>
                            <v-row>
                                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                                    <v-text-field label="نام و نام خانوادگی"
                                                  prepend-inner-icon="fa fa-pencil-alt" outlined dense
                                                  v-model="data.name"
                                                  counter maxlength="30"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                                    <v-text-field label="نام پدر" outlined prepend-inner-icon="fa fa-pencil-alt" dense
                                                  v-model="data.father_name"
                                                  counter maxlength="40"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                                    <v-text-field label="شغل" outlined prepend-inner-icon="fa fa-pencil-alt" dense
                                                  v-model="data.job"
                                    ></v-text-field>
                                </v-flex>
                            </v-row>
                            <v-row>

                                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                                    <v-text-field type="text" @keypress="allowOnlyNumbers($event)" counter
                                                  maxlength="10" label="کدملی"
                                                  outlined
                                                  prepend-inner-icon="fa fa-pencil-alt" dense
                                                  v-model="data.national_id"
                                                  :rules="rules.national_code"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                                    <v-text-field label="شماره شناسنامه" @keypress="allowOnlyNumbers($event)" outlined
                                                  prepend-inner-icon="fa fa-pencil-alt"
                                                  dense
                                                  v-model="data.certificate_id"
                                                  :rules="rules.isInt"
                                                  maxlength="10" counter
                                    ></v-text-field>
                                </v-flex>
                                <v-flex class="p-2 d-flex d-inline" xs12 sm12 md4 lg4 xl4>
                                    <v-autocomplete
                                            :items="provinces"
                                            item-text="name"
                                            v-model="data.province_id"
                                            :error-messages="errors.province"
                                            item-value="id"
                                            label="استان"
                                            dense outlined
                                    ></v-autocomplete>

                                </v-flex>

                            </v-row>
                            <v-row>

                                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                                    <date-picker label="تاریخ تولد"
                                                 view="year"
                                                 format="YYYY-MM-DD"
                                                 display-format="jYYYY-jMM-jDD"
                                                 max="2006-01-01"
                                                 start="2006-01-01"
                                                 v-model="data.birthday"/>
                                </v-flex>
                                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                                    <v-text-field label="محل تولد" outlined prepend-inner-icon="fa fa-pencil-alt" dense
                                                  v-model="data.birthplace"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex class="p-2 d-flex d-inline" xs12 sm12 md4 lg4 xl4>
                                    <v-autocomplete
                                            :items="filteredCity"
                                            item-text="name"
                                            v-model="data.city_id"
                                            item-value="id"
                                            label="شهر"
                                            dense outlined
                                    ></v-autocomplete>
                                </v-flex>
                            </v-row>
                            <v-row>
                                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                                    <v-text-field @keypress="allowOnlyNumbers($event)" label="شماره تلفن" outlined
                                                  prepend-inner-icon="fa fa-pencil-alt"
                                                  :error-messages="errorPhone"
                                                  dense v-model="data.phone"
                                                  maxlength="11" counter
                                                  :rules="rules.isInt"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex class="p-2 d-flex d-inline" xs12 sm12 md4 lg4 xl4>
                                    <v-text-field @keypress="allowOnlyNumbers($event)" label="شماره موبایل" outlined
                                                  prepend-inner-icon="fa fa-pencil-alt"
                                                  dense v-model="data.mobile"
                                                  :error-messages="errorMessage"
                                                  maxlength="11" counter
                                                  :rules="rules.isInt"
                                    ></v-text-field>
                                    <v-btn icon v-if="!showOtherPhone" rounded class="mr-2 btn-add-with-text"
                                           style="top: -9px!important;"
                                           @click="showOtherPhone = ! showOtherPhone">
                                        <v-icon>mdi-plus</v-icon>
                                    </v-btn>
                                </v-flex>
                                <v-flex v-if="showOtherPhone || data.mobile_plus!=null" class="p-2 d-flex d-inline" xs12
                                        sm12 md4 lg4 xl4>
                                    <v-text-field @keypress="allowOnlyNumbers($event)" label="شماره دیگر" outlined
                                                  prepend-inner-icon="fa fa-pencil-alt"
                                                  dense v-model="data.mobile_plus"
                                                  :error-messages="errorPhonePlus"
                                                  maxlength="11" counter
                                                  :rules="rules.isInt"
                                    ></v-text-field>
                                    <v-btn icon @click="closeInput" rounded class="mr-2 btn-exit"
                                           style="top: -9px!important;">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </v-flex>
                            </v-row>
                            <v-row>
                                <v-flex class="p-2" xs12 sm12 md6 lg6 xl6>
                                    <v-textarea label="آدرس" outlined prepend-inner-icon="fa fa-pencil-alt" dense
                                                v-model="data.address"
                                    ></v-textarea>
                                </v-flex>
                                <v-flex class="p-2" xs12 sm12 md6 lg6 xl6>
                                    <v-textarea label="توضیحات" outlined prepend-inner-icon="fa fa-pencil-alt" dense
                                                v-model="data.description"
                                    ></v-textarea>
                                </v-flex>
                            </v-row>
                            <v-btn v-if="edit == ''" class="submit-btn float-left" @click="addCustomer">
                                <span style="font-size: 1.2rem" class="fa fa-save ml-2"></span>
                                ثبت کاربر جدید
                            </v-btn>
                            <v-btn v-else class="submit-btn float-left" @click="updateCustomer">
                                <span style="font-size: 1.2rem" class="fa fa-save ml-2"></span>
                                ویرایش اطلاعات
                            </v-btn>
                        </v-card-text>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>

import CitySelector from "../divarDependency/citySelector";
import {Axios2} from "../../../../main";

export default {
    name: "newCustomer",
    components: {CitySelector},
    props: {
        tab: {
            default: 1
        },
        edit: {
            default: ''
        },
        modal: {
            default: false
        },
        reload: {},
        from: {
            default:''
        },
    },
    data() {
        return {
            loading: false,
            errors: [],
            provinces: [],
            cities: [],
            rules: {
                national_code: [
                    (val) => !val || this.checkNationalCode(this.english(val)) || "کد ملی اشتباه است.",
                ],
                isInt: [
                    (val) => !val || Number(val.toString()) || 'فقظ عدد وارد کنید'
                ]

            },
            filteredCity: [],
            errorMessage: '',
            errorPhonePlus: '',
            errorPhone: '',
            showOtherPhone: false,
            data: {
                province_id: null,
                city_id: null,
                name: null,
                father_name: null,
                job: null,
                national_id: null,
                certificate_id: null,
                phone: null,
                birthday: null,
                birthplace: null,
                mobile: null,
                mobile_plus: null,
                address: null,
                description: null,
            }
        }
    },
    mounted() {
        this.getProvincies();
        if (this.edit !== '') {
            this.getDataForEdit();
        }
    },
    methods: {
        checkNationalCode(code) {
            var xv = code;
            if (isNaN(xv)) {
                return false;
            } else if (xv == "") {
                return false;
            } else if (xv.length < 10) {
                return false;
            } else {
                var yy = 0;
                var yv = parseInt(yv);
                for (let i = 0; i < xv.length; i++) {
                    yv = xv[i] * (xv.length - i);
                    yy += yv;
                }
                var x = yy % 11;
                if (x === 0) {
                    return true;
                } else {
                    return false;
                }
                yy = 0;
            }
        },
        addCustomer() {
            this.$modal.showLoading();
            this.loading = true;
            Axios2.post('user/customer', {...this.data})
                .then(({data}) => {
                    this.$modal.hideLoading();
                    this.tab = 0;
                    this.$emit('input',data.data)
                    this.$modal.success('مشتری با موفقیت اضافه شد.');
                    this.resetPage();
                }).catch((err) => {
                this.loading = false;
                this.$modal.hideLoading();
                this.$modal.error('خطا!', '', Object.keys(err.response.data.errors).map((key) => {
                    return err.response.data.errors[key][0]
                }).join('\n'));
            });
        },
        updateCustomer() {
            this.$modal.showLoading();
            this.loading = true;
            Axios2.put(`user/customer/${this.edit}`, {...this.data})
                .then(({data}) => {
                    this.$modal.hideLoading();
                    this.reload();
                    this.tab = 0
                    this.$modal.success('مشتری با موفقیت به روزرسانی شد.');
                    this.modal();
                }).catch((err) => {
                this.loading = false;
                this.$modal.hideLoading();
                this.$modal.error('خطا!', '', Object.keys(err.response.data.errors).map((key) => {
                    return err.response.data.errors[key][0]
                }).join('\n'));
            })
        },
        getProvincies() {
            Axios2.get('setting/province').then((res) => {
                this.provinces = res.data.data.provinces;
                this.cities = res.data.data.cities
            })
        },
        getDataForEdit() {
            Axios2.get(`user/customer/${this.edit}`).then((res) => {
                this.data = res.data.data
            })
        },
        allowOnlyNumbers(value) {
            let allowedKeys = [8, 46, 38, 40, 37, 39];
            const keypressed = value.which || value.keyCode;
            if (/[^0-9\s]+/.test(value.key)) {
                if (allowedKeys.every(e => e !== keypressed)) {
                    value.preventDefault();
                }
            } else return true
        },
        closeInput() {
            this.data.mobile_plus = null;
            this.showOtherPhone = !this.showOtherPhone
        },
        resetPage() {
            this.data.province_id = null;
            this.data.city_id = null;
            this.data.name = null;
            this.data.father_name = null;
            this.data.job = null;
            this.data.national_id = null;
            this.data.certificate_id = null;
            this.data.phone = null;
            this.data.birthday = null;
            this.data.birthplace = null;
            this.data.mobile = null;
            this.data.mobile_plus = null;
            this.data.address = null;
            this.data.description = null;
        }
    },
    watch: {
        'data.province_id': function (val) {
            this.filteredCity = this.cities.filter((city) => city.province_id === val);
        },
        'data.mobile': function (val) {
            if (val.length < 11) {
                this.errorMessage = 'شماره وارد شده نمیتواند کمتر از 11 رقم باشد.'
            } else
                this.errorMessage = ''
        },
        'data.mobile_plus': function (val) {
            if (val.length < 11) {
                this.errorPhonePlus = 'شماره وارد شده نمیتواند کمتر از 11 رقم باشد.'
            } else
                this.errorPhonePlus = ''
        },
        'data.phone': function (val) {
            if (val.length < 11) {
                this.errorPhone = 'شماره وارد شده نمیتواند کمتر از 11 رقم باشد.'
            } else
                this.errorPhone = ''
        },
    }
}
</script>

<style scoped>
</style>
